import React, { useState } from "react";
import "../../styles/forgetpassword.css";
import axios from "axios";
import { useDispatch } from "react-redux";
import { loginReducer } from "../../Redux/store";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

function ForgotPassword() {
  const dispatch = useDispatch();
  const [string, setString] = useState("");

  var regex = new RegExp(/[@]/g);
  let boolen = regex.test(string);

  const data = boolen ? { email: string } : { username: string };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const resp = await axios.put("auth/forgotpassword", data, {
        headers: { "content-type": "application/json" },
      });
      if (resp.status === 200) {
        dispatch(loginReducer.Forget_password(false));
      }
    } catch (err) {
      // console.log(err);
    }
   
  };

  return (
    <div className="container-fluid g-0 m-0 p-0" style={{ overflow: "hidden" }}>
      <div className="row ">
        <div
          className="col-lg-6 col-md-6  text-center col-sm-12"
          style={{ marginTop: "165px", marginBottom: "75px" }}
        >
          <form onSubmit={handleSubmit}>
            <h2>
              <strong>Forget Password!</strong>
            </h2>
            <Box
              component="form"
              sx={{
                "& > :not(style)": { m: 1, width: "36ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                id="Username"
                label="User name/Email ID"
                type={boolen ? "email" : "text"}
                variant="outlined"
                maxLength={"15"}
                value={string}
                onChange={(e) => {
                  const { value } = e.target;
                  setString(value);
                }}
                // style={{ backgroundColor: "grey" }}
              />
            </Box>

            <button className="btn1" type="submit">
              Generate Password
            </button>
            <br></br>

            <button
              className="btn1"
              onClick={() => {
                dispatch(loginReducer.Forget_password(false));
              }}
            >
              Cancel/Login
            </button>
          </form>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <img
            className="Logo"
            width="100%"
            height="100%"
            src={require("../../images/desktop_img.png")}
            alt="TATA Elxsi"
          ></img>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
